// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"1083":"cc00fa56","8434":"31420fc2"}[chunkId] + ".chunk.css";
};